import { connect } from "react-redux";
import { RootState } from "app/rootReducer";
import DashboardLoginView from "./DashboardLoginView";
import { showDialog, loginDashboard as onLoginDashboard, AuthDialog, login as onLoginUser, loginSocial as onLoginSocial } from "../reducer";

const mapStateToProps = (state: RootState) => ({
    error: state.auth.error,
    userError: state.user.error,
    isLoading: state.auth.isLoading,
    isCompayProfile: state.user.isCompanyProfile,
});

const mapDispatchToProps = {
    onForgotPassword: () => showDialog(AuthDialog.ForgotPassword),
    onLoginDashboard,
    onLoginSocial,
    onLoginUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(DashboardLoginView);
